// datepicker の読み込み設定

// こちらの初期化を希望する。
// <script src="/theme/sn-default/lib/jquery-ui-1.13.0/jquery-ui.min.js"></script>
// <script src="/theme/sn-default/lib/jquery-ui-1.13.0_ex/datepicker-ja.js"></script>
// <link rel="stylesheet" href="/theme/sn-default/lib/jquery-ui-1.13.0/jquery-ui.min.css">


(function () {
    // console.log('call form calendar v2');

    // グローバル空間にオブジェクトを生成 (既にある場合はそのまま)
    window.ssjk2021 = window.ssjk2021 || {};

    function CreateReservationFacilityFormApp(js_params){

        // console.log("CreateReservationFacilityFormApp");
        // console.log(js_params);

        const val_input_id = js_params.val_input_id;
        const datepicker_id = js_params.datepicker_id;
        const fac_vue_id = js_params.fac_vue_id;

        ////
        const fac_vue_css_tgt = "#" + fac_vue_id;

        var app = new Vue({
            el: fac_vue_css_tgt,
            data: {
                // formでの入力値に同期 {facility_id: 1, reserved_date: '2021-12-10', reserved_time_block: 10 }
                facility_id: js_params.facility_id,
                // reserved_date は watchするため、別立てに。 dtpicker_obj.datepicker("setDate", view_date); での同期実施
                reserved_date_direct: js_params.reserved_date,
                reserved_time_block: js_params.reserved_time_block,

                // 月選択時に更新、日付キーで、 reserved_time_block_options に入る選択肢を保持。
                date_to_blk_opts: js_params.date_to_blk_opts,
                // カレンダーで選択中月
                view_month: null,
                // 時間枠セレクタ options タグに同期
                reserved_time_block_options: js_params.reserved_time_block_options,
            },
            watch: {
                // reserved_date の値変更で、datepicker も変更
               reserved_date_direct: function (newval, oldval){
                   // console.log("watch reserved_date old:'" + oldval + "', new:'" + newval + "'");
                   var now_dt_val = dtpicker_obj.datepicker("getDate");
                   var now_dt_val_s = $.datepicker.formatDate('yy-mm-dd', now_dt_val);
                   if(now_dt_val_s != newval){
                       // console.log("datepicker set reserved_date '" + now_dt_val + "' -> '" + newval + "'");
                       dtpicker_obj.datepicker("setDate", newval);
                   }
               },
            },
            computed: {
                reserved_date: function (){
                    const sel_month_s = $.datepicker.formatDate('yy-mm', this.view_month);
                    const sel_day_month_s = this.reserved_date_direct.substring(0, 7);
                    // console.log("reserved_date calc. " + sel_month_s + "," + sel_day_month_s);
                    if(sel_month_s === sel_day_month_s){
                        return this.reserved_date_direct;
                    }

                    return '';
                },
                isSelectedFacility: function(){
                    // console.log('isSelectedFacility');
                    // console.log(this.attributes);
                    return (0 < this.facility_id);
                },
                isShowReservedTimeBlockSelect: function (){
                    // console.log("isShowReservedTimeBlockSelect");
                    // console.log(this.reserved_time_block_options.length);
                    return (0 < this.reserved_time_block_options.length);
                    // return true;
                },
            },
            methods: {
                clearFacilitySelection: function (){
                    // クリアボタン押した際は全選択肢クリア
                    this.facility_id = 0;
                    this.reserved_time_block = 0;

                    this.date_to_blk_opts = {};
                    this.reserved_time_block_options = [];

                    this.reserved_date_direct = '';
                },
            },
            mounted: function (){
                // console.log('vue mounted.');
            }
        });
        // console.log(app);
        var vueObj = app;

        ///////

        $.datepicker.setDefaults($.datepicker.regional["ja"]);

        const val_input_css_tgt = "#" + val_input_id;
        const dtpicker_css_tgt = "#" + datepicker_id;

        const input_obj = $(val_input_css_tgt);
        // console.log(input_obj);
        const fac_id = input_obj.data("fac-css-tgt");

        const dtpicker_obj = $(dtpicker_css_tgt);

        dtpicker_obj.datepicker({
            altField       : val_input_css_tgt,
            changeMonth    : false,
            changeYear     : false,
            dateFormat     : "yy-mm-dd",
            numberOfMonths : 1,
            showButtonPanel: false,
            showOn         : "both",
            showOtherMonths: true,
            beforeShowDay: function (day) {
                // 指定日が有効かどうか判定
                // console.log("beforeShowDay" + day + " " + targeted_month);
                const yymmdd = $.datepicker.formatDate('yy-mm-dd', day);
                // console.log(yymmdd);

                const date_to_blk_opts = vueObj.date_to_blk_opts || {};
                // console.log(date_to_blk_opts[yymmdd]);

                const target_days = Object.keys(date_to_blk_opts);
                // console.log("target_days" + target_days);

                if ($.inArray(yymmdd, target_days) == -1) {
                    return [false, ""];
                }
                else {
                    return [true, ""];
                }
            },
            onChangeMonthYear: function (year, month) {
                // カレンダーで月選択したため、date_to_blk_opts を更新
                // console.log("datepickeron onChangeMonthYear " + year + "-" + month);

                vueObj.view_month = new Date(year, month - 1, 1);
                updateCalTargetDays(vueObj, dtpicker_obj);
            },
            onSelect: function (dateText) {
                vueObj.reserved_date_direct = dateText;
                selectReservedDate(vueObj, dateText);
            }
        });
        // console.log("dtpicker_obj.datepicker called");

        // form_objectの設定値をパース、datepicker側に初期値設定する準備。
        const cur_val = vueObj.reserved_date_direct;
        let date_nums = [];
        if (cur_val !== "") {
            date_nums = /^(\d+)-(\d+)-(\d+)/.exec(cur_val);
        }
        // datepicker 側の初期値設定。
        let view_date = null;
        if (date_nums.length === 4) {
            view_date = new Date(date_nums[1], date_nums[2] - 1, date_nums[3]);
        }
        else{
            view_date = '';
        }
        // console.log("setDate" + date_nums + "," + view_date);

        dtpicker_obj.datepicker("setDate", view_date);

        // console.log('prepare date');
        let ctrl_date = view_date || new Date;
        // console.log(ctrl_date);
        vueObj.view_month = ctrl_date;

        // 初期化
        updateCalTargetDays(vueObj, dtpicker_obj);
        $(fac_id).change(function (){
            updateCalTargetDays(vueObj, dtpicker_obj);
        })
    }

    // datepicker から vueObj.reserved_date 更新　
    function selectReservedDate(vueObj, dateText){
        // 日付選択し、時間枠セレクタが確定
        // console.log("datepicker onSelect");
        // console.log(dateText);

        const date_to_blk_opts = vueObj.date_to_blk_opts;
        // console.log(date_to_blk_opts[dateText]);
        // console.log(blk_input_css_tgt);
        const blk_opts = date_to_blk_opts[dateText] || [];
        // console.log(blk_opts);

        // dtpicker_obj.datepicker内の値決まったため、js側変数に反映、時間枠セレクタも確定。
        vueObj.reserved_time_block_options = blk_opts;
        if(0 < blk_opts.length){
        }
        else{
            // TODO: 検討 月選択時に1回クリアしたいが、setDateするとdatepickerの月選択も連動しようとし、
            //           12月の次月 1月おしたが、一回キャンセルされ 12月になり、再度押さないといけなくなるため、一旦抑制。
            // vueObj.reserved_date = '';
        }

        // 日付選択の結果、今までの選択値が範囲外なら1番目に設定。
        // console.log("日付選択の結果、今までの選択値が範囲外なら1番目に設定。");
        const current_blk = vueObj.reserved_time_block;
        let isSelected = false;
        let firstValue = null;
        for(const opt_idx in blk_opts){
            const opt = blk_opts[opt_idx];
            // console.log(opt);
            if(current_blk === opt.value){
                // // console.log("found ok reserved_time_block");
                // console.log(current_blk);
                isSelected = true;
                break;
            }
            if(!firstValue){
                firstValue = opt.value;
                // console.log("firstvalue reserved_time_block");
                // console.log(firstValue);
            }
        }
        if(!isSelected){
            // console.log("force update reserved_time_block");
            // console.log(firstValue);
            vueObj.reserved_time_block = firstValue;
        }
    }

    function setFailStateSelectOption(vueObj){
        // console.log("setFailStateSelectOption");

        vueObj.reserved_time_block = 0;
        vueObj.reserved_date_direct = '';

        vueObj.date_to_blk_opts = {};
        vueObj.reserved_time_block_options = [];
    }

    // 選択したfac_id と dtpickerで選択中年月から apiへ選択可能日付、時間枠をもらい、
    // date_to_blk_opts 更新、dtpicker再描画。
    function updateCalTargetDays(vueObj, dtpicker_obj){
        // console.log("updateCalTargetDays");
        // console.log(vueObj);

        const tgt_date = vueObj.view_month;

        // console.log(tgt_date);
        const fac_val = vueObj.facility_id;
        // console.log(fac_val);
        if(fac_val === undefined){
            setFailStateSelectOption(vueObj);
            dtpicker_obj.datepicker("refresh");
            return false;
        }

        const year = tgt_date.getFullYear();
        const month = (tgt_date.getMonth() + 1);

        const acc_url = "/api/cal_target_days/?year=" + year + "&month=" + month + "&facility=" + fac_val;
        // console.log(acc_url);

        // APIで施設、月毎の時間枠選択肢をもらって保持しておく。
        $.ajax({
            url: acc_url,
        }).done(function(data,textStatus,jqXHR) {
            // console.log(data);
            // console.log(jqXHR);
            // console.log(textStatus);
            const date_to_blk_opts = data["target_date_to_blk_opts"] || {};

            vueObj.date_to_blk_opts = date_to_blk_opts;
            dtpicker_obj.datepicker("refresh");

            selectReservedDate(vueObj, vueObj.reserved_date_direct);

        }).fail(function(jqXHR, textStatus, errorThrown ) {
            // console.log(jqXHR);
            // console.log(textStatus);
            // console.log(errorThrown);

            setFailStateSelectOption(vueObj);
            dtpicker_obj.datepicker("refresh");
        });
    }

    // ここが有効になればグローバルに使えるようになる。
    window.ssjk2021.CreateReservationFacilityFormApp = CreateReservationFacilityFormApp;
})();
